import './bootstrap';
import { createApp } from 'vue';
import PrimeVue from 'primevue/config';
import Lara from '@primevue/themes/lara';
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import Textarea from 'primevue/textarea';
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import App from './components/SiteApp.vue';

const root = document.getElementById('app');

if (root) {
    createApp(App, window.RE_INFORMATICA || {})
        .use(PrimeVue, {
            theme: {
                preset: Lara,
                options: {
                    darkModeSelector: '.app-dark',
                },
            },
        })
        .component('PButton', Button)
        .component('PInputText', InputText)
        .component('PTextarea', Textarea)
        .component('PTabs', Tabs)
        .component('PTabList', TabList)
        .component('PTab', Tab)
        .component('PTabPanels', TabPanels)
        .component('PTabPanel', TabPanel)
        .mount(root);
}
